import { Guild } from '../../utils/types'
import styles from './item.module.scss'

type Props = {
    guild: Guild;
}

export const GuildMenuItem = ({ guild }: Props) => {
    const url = `https://cdn.discordapp.com/icons/${guild.id}/${guild.icon}`
    let guild_url = guild.icon ? url : '/dreamvast.png'
    return(
        <div className={styles.container}>
            <img
                src={guild_url}
                height={55} 
                width={55} 
                className={styles.image} 
                alt={guild.name}
            />
            <div className={styles.line}/>
            <p className={styles.text}>{guild.name}</p>
        </div>
    )
}